import { Box, Typography } from '@mui/material';

export default function Title({ cameraName, loading }) {
    return cameraName && (
        <Box className="Title">
            <Box className="Title-Label">
                <Typography variant="body1" className={loading ? "Title-CameraLabel-disabled" : "Title-CameraLabel"}>
                    {cameraName}
                </Typography>
            </Box>
        </Box>
    )
}